import { FC } from 'react';
import dgLoadingAnimation from '../../assets/dg-rocket.gif';

const SkillStateUpdateLoader: FC = () => {
  return (
    <div className="w-full paper-grid-bg !tw-bg-[#F9F8F5]">
      <div className="tw-w-[50%] tw-h-[40%] tw-mx-auto tw-flex tw-justify-center tw-items-center">
        <div>
          <img alt="loading" src={dgLoadingAnimation} className="tw-w-[15rem] tw-h-[15rem]" />
          <h1 className="tw-text-[1.5rem] tw-text-center">Building your path...</h1>
          <p className="tw-text-center">Just a moment while we put it together.</p>
        </div>
      </div>
    </div>
  );
};

export default SkillStateUpdateLoader;
